



































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { WithUID, generateUID } from '@/utils/utils';
import { GQL_CustomerContactCreate, GQL_CustomerContactUpdate } from '@/queries/global';

@Component
export default class CustomerFormCustomerContacts extends Vue {
  @Prop({ type: Array, required: true }) private customerContacts!: WithUID<GQL_CustomerContactCreate | GQL_CustomerContactUpdate>[];

  @Watch('customerContacts', { immediate: true })
  private ensureUIDsAreSet(): void {
    this.customerContacts.forEach(customerContact => {
      if (!customerContact.$_UID) {
        customerContact.$_UID = generateUID();
      }
    });
  }

  private addCustomerContact(): void {
    this.customerContacts.push({
      id: undefined,
      firstName: undefined,
      lastName: undefined,
      phone: undefined,
      email: undefined,
      jobTitle: undefined,
      comment: undefined,
      _destroy: undefined,
      $_UID: generateUID(),
    } as WithUID<GQL_CustomerContactCreate | GQL_CustomerContactUpdate>);
  }

  public removeCustomerContact(customerContact: WithUID<GQL_CustomerContactCreate | GQL_CustomerContactUpdate>) {
    if ('id' in customerContact && customerContact.id) {
      Vue.set(customerContact, '_destroy', true);
    } else {
      this.customerContacts.splice(
        this.customerContacts.indexOf(customerContact),
        1,
      );
    }
  }

  private get notDeletedCustomerContacts() {
    return this
      .customerContacts
      .filter((customerContact: GQL_CustomerContactCreate | GQL_CustomerContactUpdate) =>
        !('_destroy' in customerContact) ||
        !customerContact._destroy,
      );
  }
}
